import React from 'react';
import { Image, Table } from 'antd';
import HtmlParser from 'react-html-parser';

/**
 * Kiểm tra chuỗi có phải là HTML hay không.
 */
const isHtmlContent = (text) => {
    return typeof text === 'string' && /<\/?[a-z][\s\S]*>/i.test(text.trim());
};

const flattenObject = (obj, prefix = '') => {
    let result = {};
    for (let key in obj) {
        if (!obj.hasOwnProperty(key)) continue;
        const value = obj[key];
        const path = prefix ? `${prefix}.${key}` : key;

        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                const arrayPath = `${path}[${index}]`;
                if (typeof item === 'object' && item !== null) {
                    Object.assign(result, flattenObject(item, arrayPath));
                } else {
                    result[arrayPath] = item;
                }
            });
        } else if (typeof value === 'object' && value !== null) {
            Object.assign(result, flattenObject(value, path));
        } else {
            result[path] = value;
        }
    }
    return result;
};


/**
 * So sánh trước/sau và tạo dữ liệu diff.
 */
const renderDiff = (before = {}, after = {}) => {
    const flatBefore = flattenObject(before);
    const flatAfter = flattenObject(after);
    const allKeys = Array.from(new Set([...Object.keys(flatBefore), ...Object.keys(flatAfter)]));

    return allKeys.map((key) => {
        const beforeValue = flatBefore[key] ?? '';
        const afterValue = flatAfter[key] ?? '';
        const changed = beforeValue !== afterValue;

        return {
            key,
            field: key,
            before: beforeValue,
            after: afterValue,
            changed,
        };
    });
};


/**
 * Hàm xử lý render 1 ô trong bảng.
 */
const isImageUrl = (url) =>
    typeof url === 'string' && /^https?:\/\/.*\.(jpg|jpeg|png|webp|gif)$/i.test(url.trim());

const renderCell = (text, record, type) => {
    const value = record?.[type];
    if (value === null || value === undefined || value === '') return '—';

    const safeText = String(value).trim();

    const color = type === 'before' ? 'red' : 'green';

    let content;

    if (isImageUrl(safeText)) {
        content = (
            <Image
                src={safeText}
                alt="img"
                style={{ maxWidth: 120, maxHeight: 80, borderRadius: 4, border: '1px solid #ddd' }}
            />
        );
    } else if (isHtmlContent(safeText)) {
        content = HtmlParser(safeText);
    } else {
        content = safeText;
    }

    return record.changed ? (
        <span style={{ color }}>
            {typeof content === 'string' ? content : <>{content}</>}
        </span>
    ) : content;
};


const AuditLogDiffTable = ({ before, after }) => {
    const allDiffs = renderDiff(before, after);
    const dataSource = allDiffs.filter(item => item.changed); // chỉ giữ các trường đã thay đổi

    const columns = [
        {
            title: 'Trường',
            dataIndex: 'field',
            width: 150,
            render: (text) => <strong>{text || '—'}</strong>,
        },
        {
            title: 'Trước',
            dataIndex: 'before',
            render: (_, record) => renderCell(record.before, record, 'before'),
        },
        {
            title: 'Sau',
            dataIndex: 'after',
            render: (_, record) => renderCell(record.after, record, 'after'),
        },
    ];

    return (
        <Table
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            size="small"
            bordered
            rowKey="key"
            locale={{ emptyText: 'Không có thay đổi nào' }}
        />
    );
};


export default AuditLogDiffTable;